import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=449a22f5&scoped=true"
import script from "./AddChannel.vue?vue&type=script&lang=js"
export * from "./AddChannel.vue?vue&type=script&lang=js"
import style0 from "./AddChannel.vue?vue&type=style&index=0&id=449a22f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a22f5",
  null
  
)

export default component.exports